import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'public-app-shell',
    imports: [],
    templateUrl: './app-shell.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app-shell.component.css'
})
export class AppShellComponent {}
